<div>
  <mat-card>
    <mat-card-header class="titreFrm">
      <mat-card-title>PLANNING {{ titre }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
      <mat-accordion>
        <mat-expansion-panel expanded="true" class="px-8">
          <mat-expansion-panel-header [collapsedHeight]="'30px'" [expandedHeight]="'30px'"></mat-expansion-panel-header>
          <div>
            <mat-form-field *ngIf="ecran == 'action'" appearance="outline">
              <mat-label>Liste Actions</mat-label>
              <mat-select (selectionChange)="actionChange()" placeholder="Liste Actions" name="avtActions"
                [(ngModel)]="code">
                <mat-option *ngFor="let action of listeActions" [value]="action.avtAction_Code">
                  {{ action.avtAction_Intitule }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <app-recherche *ngIf="showRecherche && ecran != 'action'" [disabled]="disabled" [api]="generalService.api"
              [numColonneToShow]="numColonneToShow" (ChampEnter)="blurChamp($event)" [recherche]="recherche"
              [param]="param1Recherche" [param2]="param2Recherche" name="xx" [placeholder]="titre">
            </app-recherche>
            <mat-form-field appearance="outline">
              <mat-label>Du</mat-label>
              <input (dateChange)="dateChange()" matInput [matDatepicker]="dateDebut" placeholder="Du"
                [(ngModel)]="date_Debut" />
              <mat-datepicker-toggle matSuffix [for]="dateDebut"></mat-datepicker-toggle>
              <mat-datepicker #dateDebut></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Au</mat-label>
              <input (dateChange)="dateChange()" matInput [matDatepicker]="dateFin" placeholder="Au"
                [(ngModel)]="date_Fin" />
              <mat-datepicker-toggle matSuffix [for]="dateFin"></mat-datepicker-toggle>
              <mat-datepicker #dateFin></mat-datepicker>
            </mat-form-field>
          </div>
          <!-- <div class="content-liste-btn p-8">
            <div *ngFor="let week of listWeek" class="div-btn">
              <button
                [disabled]="!week.enable"
                mat-raised-button
                (click)="showDetaille(week.monthName, 'timeGridWeek')"
                color="primary"
              >
                <span>{{ week.colSpan }}</span
                >&nbsp;&nbsp;<span style="font-size: 10px">{{
                  week.monthName
                }}</span>
              </button>
            </div>
          </div> -->
          <!-- <div class="content-liste-btn p-8">
            <div *ngFor="let month of listMonth" class="div-btn">
              <button
                [disabled]="!month.enable"
                (click)="
                  showDetaille(
                    '1/' + (month.monthId + 1) + '/' + month.year,
                    'dayGridMonth'
                  )
                "
                mat-raised-button
                color="primary"
              >
                {{ month.monthName }}
              </button>
            </div>
          </div> -->
        </mat-expansion-panel>
      </mat-accordion>
      <button (click)="openAdd()" mat-raised-button class="colorGreen">
        <mat-icon>add</mat-icon>
        Ajouter
      </button>

      <div style="margin-top: 10px">
        <app-calendar *ngIf="events.length>0 && !refreshing" #calendarComponent [events]="events"
          (actionCalendar)="getdetailCrm($event)" [intervale]="intervale" [date_Fin]="date_Fin"
          [date_Debut]="date_Debut" [defaultDate]="defaultDate" [selectable]='false' [htmlTitre]="true"
          [editable]='true'>
        </app-calendar>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #frmAjout>
  <ng-container class="py-8 w-full" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="center center">
      <mat-card-title style="color:#1e88e5;" class="text-4xl text-center">Planification </mat-card-title>
    </div>
    <div fxLayout="column">
      <br>
      <div fxLayout="row" fxLayoutAlign="center none">
        <mat-card class="w-full">
          <mat-card-content>
            <app-recherche class="w-full" *ngIf="!chooseDialog" [api]="generalService.api" [numColonneToShow]="1"
              [numColonneToReturn]="0" (ChampEnter)="blurUser($event)" recherche="user" name="user" placeholder="USER">
            </app-recherche>
            <app-recherche class="w-full" *ngIf="chooseDialog" [api]="generalService.api" [numColonneToShow]="1"
              [numColonneToReturn]="0" (ChampEnter)="blurUser($event)" recherche="user" name="user" placeholder="USER"
              [(ngModel)]="userId">
            </app-recherche>
            <div fxFlex="5"></div>



            <app-recherche class="w-full" *ngIf="!chooseDialog" [api]="generalService.api" [numColonneToShow]="1"
              [numColonneToReturn]='0' (ChampEnter)="blurClient($event)" recherche="client" name="client" #client
              placeholder="CLIENT">
            </app-recherche>
            <app-recherche class="w-full" *ngIf="chooseDialog" [api]="generalService.api" [numColonneToShow]="1"
              [numColonneToReturn]='0' (ChampEnter)="blurClient($event)" recherche="client" name="client" #client
              placeholder="CLIENT" [(ngModel)]="clientId">
            </app-recherche>
          </mat-card-content>
        </mat-card>
      </div>
      <br>
      <mat-card>
        <mat-card-content>
          <!-- <mat-form-field appearance="legacy" fxFlex="35">
          <mat-label>Date debut</mat-label>
          <input matInput [matDatepicker]="pickerdebut" [formControl]="dateDebut" >
          <mat-datepicker-toggle matSuffix [for]="pickerdebut"></mat-datepicker-toggle>
          <mat-datepicker #pickerdebut  ></mat-datepicker>
        </mat-form-field>
        <div fxFlex="30"></div>
        <mat-form-field appearance="legacy" fxFlex="35">
          <mat-label>Date fin</mat-label>
          <input matInput [matDatepicker]="pickerFin" [formControl]="dateFin">
          <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
          <mat-datepicker #pickerFin  ></mat-datepicker>
        </mat-form-field> -->

          <mat-form-field appearance="legacy">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
              <input matStartDate formControlName="start" placeholder="Start date" [(ngModel)]="datDeb">
              <input matEndDate formControlName="end" placeholder="End date" [(ngModel)]="datFin">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>

            <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
            <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
          </mat-form-field>

          <mat-form-field appearance="legacy">
            <mat-label>H.début</mat-label>
            <input matInput type="time" [value]="HeureDeb" id="HDeb" [(ngModel)]="HeureDeb" (change)="getHeuredebut($event)">
          </mat-form-field>
          <mat-form-field appearance="legacy" class="w-1/12">
            <mat-label>Durée(Min)</mat-label>
            <input matInput type="number" value="0" [(ngModel)]="duree" >
          </mat-form-field>
          <mat-form-field *ngIf="TestDuree"appearance="legacy" class="w-1/12">
            <mat-label>Duree (Heur)</mat-label>
            <input matInput type="text"  [(ngModel)]="dureeString" disabled>
          </mat-form-field>
          <mat-form-field appearance="legacy">
            <mat-label>H.Fin</mat-label>
            <input matInput type="time" [value]="HeureFin" id="HFin" [(ngModel)]="HeureFin" (change)="getHeureFin($event)">
          </mat-form-field>

        </mat-card-content>

        <mat-card-content>
          <mat-form-field appearance="legacy" fxFlex="100">
            <mat-label>Description</mat-label>
            <textarea *ngIf="!chooseDialog" matInput rows="8" cols="10"
              [(ngModel)]="CRM_DS.CRMActivity[0].CRMActivity_Description"></textarea>
            <textarea *ngIf="chooseDialog" matInput rows="8" cols="10" [(ngModel)]="eventDescp"></textarea>
          </mat-form-field>
        </mat-card-content>

        <mat-divider inset></mat-divider>
        <mat-card-actions>
          <div fxLayout="row" fxLayoutAlign="end center">
            <button *ngIf="!chooseDialog" mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial
              (click)="submit()">
              <mat-icon>add</mat-icon>Enregistrer
            </button>
            <button *ngIf="chooseDialog" mat-raised-button color="accent" [mat-dialog-close]="true" cdkFocusInitial
              (click)="modifyPlanning(eventD)">
              <mat-icon>edit</mat-icon>Modifier
            </button>
            <button *ngIf="chooseDialog" mat-raised-button color="warn" [mat-dialog-close]="true" cdkFocusInitial
              (click)="removeEvent(eventD)">
              <mat-icon>delete</mat-icon>supprimer
            </button>
            <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial>
              <mat-icon>close</mat-icon>Annuler
            </button>
          </div>
        </mat-card-actions>
      </mat-card>
    </div>


  </ng-container>
</ng-template>
